import React from "react";
import styled from "styled-components";
import { spacing, textStyle } from "../../dimensions";
import TicketInfoHeader from "./TicketInfoHeader";
import { TopSectionWrapper } from "./TicketTopSection";
import { getTextColor } from "../SeatInfov2";
var TicketTopSectionGeneric = function TicketTopSectionGeneric(_ref) {
  var accessibleTitle = _ref.accessibleTitle,
    headerTitle = _ref.headerTitle,
    mainText = _ref.mainText,
    subText = _ref.subText,
    ticketInfoButtonData = _ref.ticketInfoButtonData,
    type = _ref.type,
    wayfindingColors = _ref.wayfindingColors;
  return /*#__PURE__*/React.createElement(TopSectionWrapper, {
    $type: type,
    $wayfindingColors: wayfindingColors
  }, /*#__PURE__*/React.createElement(TicketInfoHeader, {
    accessibleTitle: accessibleTitle,
    ticketInfoButtonData: ticketInfoButtonData,
    type: type,
    headerTitle: headerTitle,
    wayfindingColors: wayfindingColors
  }), /*#__PURE__*/React.createElement(MainTextWrapper, {
    $type: type,
    $wayfindingColors: wayfindingColors
  }, /*#__PURE__*/React.createElement(BodyText, null, mainText), subText ? /*#__PURE__*/React.createElement(Reference, {
    translate: "no"
  }, subText) : null));
};
export default TicketTopSectionGeneric;
var MainTextWrapper = styled.div.withConfig({
  displayName: "TicketTopSectionGeneric__MainTextWrapper",
  componentId: "sc-1sfa0cb-0"
})(["display:flex;flex-direction:column;align-items:center;padding:", " ", " 0;color:", ";"], spacing.club, spacing.hall, function (_ref2) {
  var theme = _ref2.theme,
    $type = _ref2.$type,
    $wayfindingColors = _ref2.$wayfindingColors;
  return getTextColor(theme, $type, $wayfindingColors);
});
var BodyText = styled.p.withConfig({
  displayName: "TicketTopSectionGeneric__BodyText",
  componentId: "sc-1sfa0cb-1"
})(["margin:0;", ""], textStyle.blanc);
var Reference = styled.p.withConfig({
  displayName: "TicketTopSectionGeneric__Reference",
  componentId: "sc-1sfa0cb-2"
})(["margin:0;", " text-align:center;"], textStyle.nevis);